import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  AccessControl,
  PermissionRequired,
  //@ts-ignore
} from '@careinfo/permission-required';
import VehicleManifestList from '../pages/VehicleManifest/VehicleManifestList';
import CreateVehicleManifest from '../pages/VehicleManifest/CreateVehicleManifest';
import EditVehicleManifest from '../pages/VehicleManifest/EditVehicleManifest';

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path='/' element={<VehicleManifestList />} />
          <Route path='/vehicle-manifest' element={<VehicleManifestList />} />
          <Route path='/create' element={<CreateVehicleManifest />} />
          <Route path='/edit/:id' element={<EditVehicleManifest />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={1000} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
